import React, { useState, useCallback } from "react";
import Heading from "../ui/Heading";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { isMobile, isTablet } from "react-device-detect";
import Slider from "react-slick";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";

const data = [
  { name: "Round", para: "Cut with the optimum light refraction and sparkle.", image: `${ImageUrl}diamond-shape/round-diamond.webp`, url: "/diamonds/shape=Round" },
  { name: "Princess", para: "A contemporary cut, with optimal fire and brilliance.", image: `${ImageUrl}diamond-shape/princess-diamond.webp`, url: "/diamonds/shape=Princess" },
  { name: "Cushion", para: "With soft corners, a beautiful alternative to a round or princess cut.", image: `${ImageUrl}diamond-shape/cushion-diamond.webp`, url: "/diamonds/shape=Cushion" },
  { name: "Emerald", para: "This stylish cut creates rectangular facets with great stone clarity.", image: `${ImageUrl}diamond-shape/emerald-diamond.webp`, url: "/diamonds/shape=Emerald" },
  { name: "Oval", para: "Optimizes carat, giving the illusion of a larger stone.", image: `${ImageUrl}diamond-shape/oval-diamond.webp`, url: "/diamonds/shape=Oval" },
  { name: "Radiant", para: "The most brilliant of the rectangular cut diamonds.", image: `${ImageUrl}diamond-shape/radiant-diamond.webp`, url: "/diamonds/shape=Radiant" },
  { name: "Asscher", para: "This unique shape is a square emerald, with linear facets.", image: `${ImageUrl}diamond-shape/asscher-diamond.webp`, url: "/diamonds/shape=Asscher" },
  { name: "Marquise", para: "Elongates the finger of the wearer with a look of great grandeur.", image: `${ImageUrl}diamond-shape/marquise-diamond.webp`, url: "/diamonds/shape=Marquise" },
  { name: "Heart", para: "A rare cut that is a true testament of your relationship.", image: `${ImageUrl}diamond-shape/heart-diamond.webp`, url: "/diamonds/shape=Heart" },
  { name: "Pear", para: "Combining the brilliance and design of the Round and Marquise cuts.", image: `${ImageUrl}diamond-shape/pear-diamond.webp`, url: "/diamonds/shape=Pear" },
];

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
  beforeChange: (current, next) => {
    document
      .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
      .forEach(el => el.setAttribute('tabindex', '-1'));
  },
  afterChange: () => {
    document
      .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
      .forEach(el => el.removeAttribute('tabindex'));
  }
};

const ShopByDiamondShape = () => {
  const [diamondItem, setDiamondItem] = useState(data[0]);

  // Optimize re-renders using useCallback
  const handleClick = useCallback((item) => {
    setDiamondItem(item);
  }, []);

  return (
    <section className="shop-diamond-by-shape section-space">
      <Container fluid className="showcase-container">
        <Heading>
          <h2>Shop Diamonds By Shape</h2>
          <p>Explore Diamond Collections by Style and Make a Statement.</p>
        </Heading>

        <div className="inner-shop-diamond-shape">
          {isMobile || isTablet ? (
            <div className="diamonds-collection">
              <Slider {...sliderSettings}>
                {data.map((item) => (
                  <div
                    className="diamond-item cursor-pointer"
                    key={item.name}
                    onClick={() => handleClick(item)}
                  >
                    <Image src={item.image} alt={item.name} loading="lazy" />
                    <p className={diamondItem.name === item.name ? "name" : ""}>{item.name}</p>
                    <p className="desc">{item.para}</p>
                    <Link className="btn outline-base-btn small" to={item.url}>
                      Shop {item.name} Diamond
                    </Link>
                  </div>
                ))}
              </Slider>
            </div>
          ) : (
            <Row className="align-items-center">
              <Col md={7}>
                <div className="diamonds-collection">
                  {data.map((item) => (
                    <div
                      className="diamond-item cursor-pointer"
                      key={item.name}
                      onClick={() => handleClick(item)}
                    >
                      <Image src={item.image} alt={item.name} loading="lazy" />
                      <p className={diamondItem.name === item.name ? "font-weight-bold" : ""}>
                        {item.name}
                      </p>
                    </div>
                  ))}
                </div>
              </Col>

              <Col md={5}>
                <div className="diamonds-item-brief d-flex align-items-center">
                  <Image src={diamondItem.image} alt={diamondItem.name} loading="lazy" />

                  <div className="content">
                    <h2>{diamondItem.name}</h2>
                    <p>{diamondItem.para}</p>
                    <Link className="btn outline-base-btn small" to={diamondItem.url}>
                      Shop {diamondItem.name} Diamond
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </div>
      </Container>
    </section>
  );
};

export default ShopByDiamondShape;
